import { useState } from "react";
import Tablist from "../domains/tablist";
import Extpar from "./extpar/extpar";
import Icontools from "./icontools/icontools";
import "./domains.css";

function Domains({ advancedmode, domains, addDomain, removeDomain, colors, setExtparField, setIcontoolsField, removeIcontoolsField, gridRoot, gridLevel, twoDView, updateStateField }) {
	const [currentActive, setActive] = useState(0);

	/* the active domain does not get updated with external state changes such as with templates
	and thus needs to be checked to be in range */
	if (currentActive > domains.length - 1) setActive(0);

	return (
		<div className="domains-section">
			<h1 className={"content-title"} id="domain-parameters">Domain Specific Parameters</h1>
			<Tablist
				currentActive={currentActive}
				setActive={setActive}
				domains={domains}
				addDomain={addDomain}
				removeDomain={removeDomain}
				colors={colors}
			/>
			<Icontools
				domainIndex={currentActive}
				domains={domains}
				setIcontoolsField={setIcontoolsField}
				removeIcontoolsField={removeIcontoolsField}
				gridRoot={gridRoot}
				gridLevel={gridLevel}
				twoDView={twoDView}
				colors={colors}
				updateStateField={updateStateField}
			/>
			<Extpar
				advancedmode={advancedmode}
				domainIndex={currentActive}
				domains={domains}
				setExtparField={setExtparField}
			/>
		</div>
	);
}

export default Domains;
